import { User_Role } from '@occc/graphql';

export const userRoleMap: Record<User_Role, string> = {
  [User_Role.Admin]: 'Admin',
  [User_Role.AdminReadOnly]: 'Admin Read Only',
  [User_Role.CommandCenterUser]: 'Command Center User',
  [User_Role.Sitetech]: 'Sitetech',
  [User_Role.Support]: 'Support',
  [User_Role.BrandAdmin]: 'Brand Admin',
  [User_Role.BrandUser]: 'Brand User',
  // Remove these roles after they will be removed from schema
  [User_Role.RetailerNetworkAdmin]: 'Retailer Connect User',
  [User_Role.RetailerNetworkUser]: 'Retailer Connect User',
  [User_Role.SiteAdmin]: 'Retailer Connect User',
  [User_Role.SiteUser]: 'Retailer Connect User',
  // ----------------
  [User_Role.RcUser]: 'Retailer Connect User',
  [User_Role.ScanDataAdmin]: 'Scan Data Admin',
  [User_Role.ScanDataUser]: 'Scan Data User',
};
